export default __webpack_public_path__ + "static/media/goshen15.a4f0a2a9.jpg";